var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 95,
    viewBox: "0 0 96 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 95,
    height: 95,
    rx: 47.5,
    fill: "#FBE8F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 24.25,
    width: 45,
    height: 45,
    fill: "url(#pattern0_46_989)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_46_989",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_46_989",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_46_989",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFV0lEQVR4nO2dTYgcRRSA23+NXozZnfdmR4MQ/IkHEQUFUREPgiDqYT1ISDDT7/W6MYH4ExCUeFH0oLAaUWEvejDkoh4EDyqiRKO4aIjjzqvZjZHoHjRZ/+JPQtiMVM8YzDrdM93TPdXdUx8UC8Pu1Ktv3lR3V73udRyLxWKxWArOjMNn7bvkgQubzvbTTcdSSL6BjasFeKcA/6mQmwr5DwU0XatUV5qOrTAodG9SwIttwcvbTG3t+NmmY8w9UnLvFeC/AyT7TdCrmo4z1yigRwRpKUxySzS9ZjrWXNJ0xs9QSDu6CT7ZgKZNx5w7FpBXKKC3e5bsi+YNpuPOFbPlTRcpoN1RJAvy/IHVG841HXtumC27l2lpETP5mD4jMR17bmiMujcI8k8RM/mEAm+96dhzg0L3HgH6K1Im+40e67vzxprN5yjkzYL8mX8FFDkINtoE6GgD+b5u4xSgrb2cvnXI5lf6lqwq3pgA7TUtS8VtwIsNoFvCxqjXKQR4KtaHiPzOh872M/vO5FxLRv5WkK8IG+PBytbzBPjNmO8/UxuZvMDpF4W8JQOymvEyjT7fP1othSYS3D8iyHvi9UEHaiOT4CSBDta0MBWnAb+lLzTCxjZXqa4R4LmY77+ooHqlkxQK6UjuMhl4Sl8yh46rxNcL0o8xJR+TMt+WmOSW6M6dOTlGkO/+zxpytA8R+YQAr0s8qKKJVshb4py+nWwlfjStwAohuuk4pymkJ/uakpBeTS3AIohu+KeovLM/yQmcKxdZdK1SXSnAH/d3gKUv9pbWnZ9qoHkVPV+aGFXg3aGAVZ/TxX79XqkHnCfRgrxKkLbpK1l/Ja2vLPZ3SQ7XyxOXB/WX6G53HkQvIK8Q4KeTXOzSm6+C3o2h8z7SR0Mjuo7utfrrnZTg9nSxJMDjYWcwAvRGoh6yLLpR5ju7bfvHzOaHwvoVoKcS95BV0fUS39raNkpc8lRYv4LspuIhi6JnVzHqA1UaC1Fh9XN1dG9XSMeHRrRC3hUujb5WQJ7/s+d5mffodenAPse8qwXpt9Q8ZE30XMm9KvjUjY4r4If/XbnTmd/LLrZeKtXr0mH9CvD3qXrImmgFNN05I2lJ0Ltr+e9Lyb1UgH4ImS4O6XVp4x6yJLqp9/WCSwCeD/q7BnhrA+f0Hku3hkp0Hfi6oCmj25aSAH8V8E3Y1kvfQyVagbc+IJ6Z2PM68M099T1UorHzerK+Sgv6G720qZA/CJg2DuvbInrre5hEAz8bZUHevzwHfi/uxckQi6ZnAjJzty7H0gdEhfy6Anq/28arrlzS96DkVrRfS4z8kiD/GjZQZboBP56mh8hE7UDXoBmXiN0avdutHKFfD5GJ0kGrfi1OFSYPVHKcbSkrGiMs5AM/ETWTMyk6k1MH8CGF9FxjzK0M0kPqHbQrM18U4F8GKVSAjirk79r3m+zSdc6N8sQ1Sd02nDnRRUVZ0YPBih4QVvSAsKIHhBVddNG2sRWtBpgINqPRim7GkPC7Qpd0SUCrHFfXbOjXzE9hBctol/4XV0u28dgKJbrRobhFv1Yw0ebvM5zvUHGvywtMx6VLxBIT3X6agenM4eVx1YEnTMclQJ8mJlohPWh6QEof+IA8ndn63u6WZPPfNAGaTEy0flCeAH1pelAqe22m15qQnqlfvLFsZfMpknWlqpMGfmaXeJOel7LwtVUDb3REAX+ip4vEM9lisVgsFoslfyxkoMq0VdRDO8Juc8s9kqFSsUSeuphFmhmrMtUPrirkf5hoWtHDOnXQy05ROWioyvSUBvSzAL1Q6IOhxWKxWCwWi8VisVgsFouTLv8ABD4G0Jtcv4YAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS5);
export default __webpack_public_path__ + "static/media/s5.6797af5b95053c6379216a5431fe2976.svg";
export { ForwardRef as ReactComponent };